import { useState } from 'react';
import { Icon } from '@/components/Icon';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { cn } from '@/lib/utils';

/**
 * What Google Play needs once per app before Hangar can submit (P29 phase 3): Google's API cannot create an app's first
 * release, and every upload is made with a service account the app trusts. After these steps, Submit and auto-submit
 * send every build. Collapsed by default (registry Collapsible), open the first time a Google Play app is added.
 */
export function PlaySetupSteps({ defaultOpen = false }: { defaultOpen?: boolean }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <Collapsible open={open} onOpenChange={setOpen} className="rounded-md border px-3 py-1" data-testid="store-play-setup">
      <CollapsibleTrigger className="flex min-h-11 w-full items-center gap-1.5 text-left text-[13px] font-medium text-muted-foreground outline-none hover:text-foreground focus-visible:ring-[3px] focus-visible:ring-ring/50 sm:min-h-9">
        <Icon name="expand_more" size={18} className={cn('shrink-0 transition-transform duration-150', open && 'rotate-180')} />
        What Google Play needs once
      </CollapsibleTrigger>
      <CollapsibleContent>
        <ol className="mb-2 ml-5 list-decimal space-y-1.5 text-[13px] text-muted-foreground">
          <li>In Play Console, create the app and upload its first AAB by hand (download it from a build&apos;s Artifacts): Google does not accept an app&apos;s first release from anyone else.</li>
          <li>In Google Cloud, create a service account and download its JSON key. In Play Console → Users and permissions, invite its email with release rights on this app.</li>
          <li>Add that key here. From then on, Submit and auto-submit send every build to the tracks the rules allow.</li>
        </ol>
      </CollapsibleContent>
    </Collapsible>
  );
}
